import { gql } from '@apollo/client';

export const ADD_MONITORED_LABEL = gql`
    mutation CreateMonitoredLabel($createMonitoredLabelInput: CreateMonitoredLabelInput!) {
        createMonitoredLabel(input: $createMonitoredLabelInput) {
            monitoredLabel {
              id
              name
              folderContents
              archivalPeriod
              archivalMode
              addNewAccounts
              dontMove
              instances {
                account {
                    id
                    active
                    enabled
                    remoteId
                    email
                }
            }
              createdAt
              updatedAt
            }
            errors {
              path
              message
            }
        }
    }
`;

export const DELETE_MONITORED_LABEL = gql`
    mutation DeleteMonitoredLabel($deleteMonitoredLabelInput: DeleteMonitoredLabelInput!) {
        deleteMonitoredLabel(input: $deleteMonitoredLabelInput) {
            monitoredLabel {
                id
            }
        }
    }
`;

export const UPDATE_MONITORED_LABEL = gql`
    mutation UpdateMonitoredLabel($updateMonitoredLabelInput: UpdateMonitoredLabelInput!) {
        updateMonitoredLabel(input: $updateMonitoredLabelInput) {
            monitoredLabel {
              id
              name
              folderContents
              archivalPeriod
              archivalMode
              addNewAccounts
              dontMove
              instances {
                account {
                    id
                    active
                    enabled
                    remoteId
                    email
                }
              }
              createdAt
              updatedAt
            }
            errors {
              path
              message
            }
        }
    }
`;

export const FETCH_MONITORED_LABELS = gql`
    query MonitoredLabel($id: ID, $sortColumn: MonitoredLabelColumnsEnum, $sortDirection: SortDirectionEnum) {
        user {
            monitoredLabels(id: $id, sortColumn: $sortColumn, sortDirection: $sortDirection) {
                id
                name
                folderContents
                autoCreated
                autoActive
                archivalPeriod
                archivalMode
                addNewAccounts
                dontMove
                instances {
                    account {
                        id
                        active
                        enabled
                        remoteId
                        email
                        name
                    }
                }
                createdAt
                updatedAt
            }
        }
    }
`;
